import { render, staticRenderFns } from "./wdmpyy_details.vue?vue&type=template&id=3af20cb4&scoped=true&"
import script from "./wdmpyy_details.vue?vue&type=script&lang=js&"
export * from "./wdmpyy_details.vue?vue&type=script&lang=js&"
import style0 from "./wdmpyy_details.vue?vue&type=style&index=0&id=3af20cb4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af20cb4",
  null
  
)

export default component.exports